"use strict";

exports.__esModule = true;
exports.Search = exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = void 0;
var _search = require("./search");
exports.PLUGIN_KEY = _search.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _search.PLUGIN_PRIORITY;
exports.Search = _search.Search;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/search/index.js
// module id = 1545
// module chunks = 0